/* eslint-disable react-hooks/exhaustive-deps */
import { PageHead } from "shared";
import "./InvestmentsPage.scss";
import InvestmentsTopBar from "./components/InvestmentsTopBar";
import InvestmentsTabs from "./components/InvestmentsTabs";
import AddInvestmentModal from "./components/AddInvestmentModal/AddInvestmentModal";
import AssetTilesList from "./components/AssetTilesList/AssetTilesList";
import { useInvestmentsState } from "./hooks/useInvestmentsState";
import { useGetInvestmentsGrouped } from "hooks/investments";
import { GroupedInvestmentsData } from "./types";

const InvestmentsPage = () => {
  const {
    tab,
    isAdmin,
    isCompanyInfoOpenModal,
    authorizedUser,
    modalManage,
    selectedSlug,
    setAddAsset,
    closeAddAssetModal,
    handleChangeTab,
    // page,
  } = useInvestmentsState();

  const { data: groupedInvestments, isLoading: isGroupedLoading } =
    useGetInvestmentsGrouped();

  const typedGroupedData = groupedInvestments as
    | GroupedInvestmentsData
    | undefined;

  return (
    <>
      <PageHead
        title="Spółki w portfelu – podgląd inwestycji | App Reliance Pro"
        description="Zobacz wszystkie spółki w swoim portfelu inwestycyjnym. Aktualne dane, historia i wygodny dostęp w jednym miejscu."
      />

      <div className="companies">
        <InvestmentsTopBar
          tab={tab}
          isAdmin={isAdmin}
          isCompanyInfoOpenModal={isCompanyInfoOpenModal}
          onAssetSelect={setAddAsset}
        />
        <div className="dashboard-content__wrapper">
          <div className="dashboard-content">
            <InvestmentsTabs
              tab={tab}
              userRole={authorizedUser?.role}
              handleChangeTab={handleChangeTab}
            />
            {!isGroupedLoading && typedGroupedData && tab === "my" && (
              <>
                {typedGroupedData.own &&
                  Object.keys(typedGroupedData.own).length > 0 && (
                    <AssetTilesList
                      categories={typedGroupedData.own}
                      title="Aktywa zakupione poza Reliance"
                    />
                  )}
                {typedGroupedData.reliance &&
                  Object.keys(typedGroupedData.reliance).length > 0 && (
                    <AssetTilesList
                      categories={typedGroupedData.reliance}
                      title="Aktywa zakupione w Reliance"
                    />
                  )}
              </>
            )}
            {!isGroupedLoading &&
              typedGroupedData &&
              tab === "reliance" &&
              isAdmin && (
                <>
                  {typedGroupedData.reliance &&
                    Object.keys(typedGroupedData.reliance).length > 0 && (
                      <AssetTilesList categories={typedGroupedData.reliance} />
                    )}
                </>
              )}
            {tab === "other" && (
              <div className="investments-placeholder">
                <p>Tu pojawią się inne aktywa</p>
              </div>
            )}
          </div>
        </div>
      </div>

      <AddInvestmentModal
        isOpen={modalManage.type === "addAsset"}
        onClose={closeAddAssetModal}
        selectedSlug={selectedSlug}
        isAdmin={isAdmin}
        mode="add"
      />
    </>
  );
};

export default InvestmentsPage;
